module.exports = __webpack_public_path__ + "img/santaandsleigh2.884a98ac.svg";